import { Provider } from "@angular/core";
import { Ref } from "../../shared/providers/ref";
import { GeoportalLayoutProvider } from "./layout/geoportal-layout-provider";
import { GeoportalViewProvider } from "./views/geoportal-view-provider";

/**
 * Providers de alcance de sesión del feature geoportal — escopados al
 * inyector de la ruta (misma disciplina de providers escopados).
 *
 * ❌ NUNCA agregar aquí un provider con `@Injectable({ providedIn: 'root' })`.
 * ✅ Todos los providers de esta lista deben usar `@Injectable()` (sin providedIn).
 */
export const GEOPORTAL_PROVIDERS: Provider[] = [
  Ref,
  GeoportalLayoutProvider,
  GeoportalViewProvider,
];

